"use client";

import { BSRCalendar } from "./bsr/BSRCalendar";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Calendar as LegacyCalendar } from "./legacy/Calendar";

export const Calendar = createBSRExperimentIcon(LegacyCalendar, BSRCalendar);
